import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData } from '../AxiosRequest/axios';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [cache, setCache] = useState(() => {
        const saved = sessionStorage.getItem('dataCache');
        return saved ? JSON.parse(saved) : {};
    });

    const [loading, setLoading] = useState({});
    const [error, setError] = useState({});

    const load = useCallback(async (key, endpoint, options = {}) => {
        if (cache[key]) return;

        setLoading(prev => ({ ...prev, [key]: true }));
        setError(prev => ({ ...prev, [key]: null }));

        try {
            const lang = localStorage.getItem('language') || 'en';
            const data = await fetchData({ endpoint, lang, ...options });
            setCache(prev => {
                const updated = { ...prev, [key]: data };
                sessionStorage.setItem('dataCache', JSON.stringify(updated));
                return updated;
            });
        } catch (e) {
            setError(prev => ({ ...prev, [key]: e.message }));
        } finally {
            setLoading(prev => ({ ...prev, [key]: false }));
        }
    }, [cache]);

    return (
        <DataContext.Provider value={{ cache, load, loading, error }}>
            {children}
        </DataContext.Provider>
    );
};

export const useData = () => useContext(DataContext);
